function o(a, n) {
  if (!(a instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
export {
  o as default
};
//# sourceMappingURL=classCallCheck.mjs.map
